import { useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { AddButtonLink, Browse, usePagination } from '@/core/components';

import { FilterBox, SearchFilter, useSearch, useSortDirection } from '@feature/utils';

import { JournalCard } from './components/Card/JournalCard';
import { getJournalPagedOptions } from './model/JournalQuery';

export function JournalBrowse() {
  const { t } = useTranslation();
  const { sortDirection, toggleSortDirection } = useSortDirection('DESC');
  const { search, searchProps } = useSearch();
  const { pagination, useTotalElements, ...paginationProps } = usePagination({ search });
  const { data } = useSuspenseQuery(
    getJournalPagedOptions({
      ...pagination,
      sortDirection,
      search,
    }),
  );
  useTotalElements(data);

  return (
    <Browse
      actions={<AddButtonLink />}
      title={t('journals.title')}
      subtitle={t('journals.subtitle')}
      pagination={paginationProps}
      filters={
        <FilterBox>
          <SearchFilter
            label={t('label.search')}
            description={t('journals.searchBy')}
            {...searchProps}
          />
        </FilterBox>
      }
      sortDirection={sortDirection}
      sortedBy={t('journals.sortedByPublishDate')}
      toggleSortDirection={toggleSortDirection}
      data={data.list}
      renderItem={journal => (
        <JournalCard
          key={journal.id}
          journal={journal}
          to={`${journal.id}`}
        />
      )}
    />
  );
}
